import ListItemInfo from "../../molecules/ListItemInfo/ListItemInfo";
import ListItem from "../ListItem/ListItem";
import { useContext } from "react";
import { ACTIONS, PopupsContext } from "../../../contexts/PopupsContext";
import { languages } from "../../../dummyData/dummyData";
import { marketplaceRepository } from "../../../repository/marketplace.repository";
import { popupFields } from "../../templates/MarketplaceTemplate/MarketplaceTemplate";
import { UserContext } from "../../../contexts/UserContext";
import { currencyFormat } from "../../../utils/formatters";

const MarketItem = ({ data }) => {
  const { id, profile_image_small, name, description, category, price } = data;
  const { callPopup } = useContext(PopupsContext);
  const { userData } = useContext(UserContext);

  return (
    <ListItem title={name} image={profile_image_small} buttons={[
      {
        icon: "cart",
        onClick: () => callPopup({
          type: ACTIONS.FORM,
          payload: {
            header: languages.EN.labels.sendRequest,
            fields: popupFields(data, userData),
            postAction: (formData) => marketplaceRepository.sendRequest(id, { message: formData.message ?? "" }),
          },
        }),
      },
    ]}>
      <ListItemInfo value={description} />
      <ListItemInfo value={category} />
      <ListItemInfo value={currencyFormat(price)} />
    </ListItem>
  );
};

export default MarketItem;
